import React, {useEffect, useState} from "react";
import Checkbox from "@material-ui/core/Checkbox";
import { FormControlLabel, InputLabel } from "@material-ui/core";

const CheckboxEditor = (props) => {

  const checkIsBool = typeof(props.value) === "string" ? false : true;
  const isDataGrid = props.isdatagrid || false;
  const [checked, setChecked] = useState(props.value === "true" || props.value === true);
  useEffect(()=> {
    setChecked(props.value === "true" || props.value === true);
  }, [props])

  const handleChangeComplete = event => {
    const checked = event.target.checked;
    let value;
    if (checkIsBool) {
      value = checked;
    } else {
      value = checked ? "true" : "false"
    }

    if (isDataGrid) {
      const colId = props.column.colId
      props.node.setDataValue(colId, value);
    }

    if (props.onChange)
      props.onChange(value);

    setChecked(value);
  };

  if (props.labelPosition) return (
    <FormControlLabel
      style={{marginTop: 2, ...props.containerStyle}}
      value="top"
      control={
        <Checkbox
          checked={checked}
          onChange={handleChangeComplete}
          style={ props.style }
          disabled={props.disabled||props.readOnly}
          size={props.size||"medium"}
        />
      }
      label={props.label}
      labelPlacement={props.labelPosition}
    />
  )

  return (
    <>
      {props.label
        ?
          <InputLabel shrink id={`${props.id}-label`} style={{position: "relative"}} >{props.label}</InputLabel>
        :
          <></>
      }
      <Checkbox
        // checked={props.value === "true" || props.value === true}
        checked={checked}
        onChange={handleChangeComplete}
        style={ props.style }
        disabled={props.disabled||props.readOnly}
        size={props.size||"medium"}
      />
    </>
  );

}

export default CheckboxEditor;
